// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reset default styles */
html,
body,
div,
span,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  vertical-align: baseline;
  vertical-alignbackground: transparent;
}
/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
main,
menu,
nav,
section {
  display: block;
}
body {
  line-height: 1;
}
.click {
  cursor: pointer;
}
.txt-1-line {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.common-after-line::after {
  content: '';
  position: absolute;
  left: 0;
  width: 100%;
  height: 0.02rem;
  background-color: #f0f0f0;
  transform: scaleY(0.5);
  -webkit-transform: scaleY(0.5);
}
.after-icon::after {
  content: '';
  display: inline-block;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
.before-icon::before {
  content: '';
  display: inline-block;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
.dialog-msg .van-dialog__message {
  font-weight: 600;
  font-size: 0.36rem;
  line-height: 0.48rem;
  color: rgba(0, 0, 0, 0.85);
}
body {
  height: 100%;
  min-height: 100%;
  padding: 0;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, PingFang SC, Microsoft YaHei, Source Han Sans SC, Noto Sans CJK SC, WenQuanYi Micro Hei, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-overflow-scrolling: touch;
  letter-spacing: 0.45px;
  touch-action: manipulation;
}
h3,
p {
  margin: 0;
}
ol,
ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
a {
  text-decoration: none;
}
@media screen and (min-width: 540px) {
  body {
    max-width: 10.8rem;
    min-width: 6.4rem;
  }
}
:root {
  --max-width: 540px;
  --min-width: 320px;
}
body {
  height: 100%;
  min-height: 100%;
  margin: 0 auto;
}
@media screen and (min-width: 540px) {
  body {
    max-width: var(--max-width);
    min-width: var(--min-width);
  }
}
.marketing {
  background-color: white;
}
.marketing .marketing-content {
  width: 100%;
}
.marketing .marketing-content .co-terms {
  padding: 0.32rem;
  font-size: 0.24rem;
  line-height: 0.4rem;
}
.marketing-modal {
  text-align: center;
}
.marketing-modal .adm-mask {
  z-index: 1000;
}
.marketing-modal .adm-center-popup-wrap {
  z-index: 1001;
}
.marketing-modal .adm-center-popup-wrap .adm-modal-content {
  padding: 0.4rem 0.4rem 0.64rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/marketing/App.less","webpack://./src/assets/css/common.less","webpack://./src/assets/css/global.less"],"names":[],"mappings":"AAAA,yBAAyB;ACCzB;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA0DC,SAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EAEA,wBAAA;EAAyB,qCAAA;ADC1B;AACA,gDAAgD;ACGhD;;;;;;;;;;;;EAYC,cAAA;ADDD;ACIA;EACC,cAAA;ADFD;ACKA;EACC,eAAA;ADHD;ACQA;EACC,gBAAA;EACA,uBAAA;EACA,mBAAA;ADND;ACWA;EACC,WAAA;EACA,kBAAA;EACA,OAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;ADTD;ACgBA;EACC,WAAA;EACA,qBAAA;EACA,wBAAA;EACA,2BAAA;EACA,4BAAA;ADdD;ACoBA;EACC,WAAA;EACA,qBAAA;EACA,wBAAA;EACA,2BAAA;EACA,4BAAA;ADlBD;ACsBA;EAEE,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,0BAAA;ADrBF;AEvHA;EACC,YAAA;EACA,gBAAA;EACA,UAAA;EACA,0BAAA;EACA,8BAAA;EACA,6CAAA;EACA,mKAAA;EAUA,mCAAA;EACA,kCAAA;EACA,iCAAA;EACA,sBAAA;EACA,0BAAA;AFgHD;AE7GA;;EAEC,SAAA;AF+GD;AE5GA;;EAEC,SAAA;EACA,UAAA;EACA,gBAAA;AF8GD;AE3GA;EACC,qBAAA;AF6GD;AE1GA;EACC;IACC,kBAAA;IACA,iBAAA;EF4GA;AACF;AAxJA;EACE,kBAAA;EACA,kBAAA;AA0JF;AAvJA;EACC,YAAA;EACA,gBAAA;EACA,cAAA;AAyJD;AAvJA;EACC;IACC,2BAAA;IACA,2BAAA;EAyJA;AACF;AAvJA;EACC,uBAAA;AAyJD;AA1JA;EAGE,WAAA;AA0JF;AA7JA;EAKG,gBAAA;EACA,kBAAA;EACA,mBAAA;AA2JH;AAvJA;EAUE,kBAAA;AAgJF;AA1JA;EAEI,aAAA;AA2JJ;AA7JA;EAKI,aAAA;AA2JJ;AAhKA;EAOM,8BAAA;AA4JN","sourcesContent":["@import '../../assets/css/global.less';\n\n:root {\n  --max-width: 540px;\n  --min-width: 320px;\n}\n\nbody {\n\theight: 100%;\n\tmin-height: 100%;\n\tmargin: 0 auto;\n}\n@media screen and (min-width: 540px) {\n\tbody {\n\t\tmax-width: var(--max-width);\n\t\tmin-width: var(--min-width);\n\t}\n}\n.marketing {\n\tbackground-color: white;\n\t.marketing-content {\n\t\twidth: 100%;\n\t\t.co-terms {\n\t\t\tpadding: 16px;\n\t\t\tfont-size: 12px;\n\t\t\tline-height: 20px;\n\t\t}\n\t}\n}\n.marketing-modal {\n  .adm-mask {\n    z-index: 1000;\n  }\n  .adm-center-popup-wrap {\n    z-index: 1001;\n    .adm-modal-content {\n      padding: 20px 20px 32px;\n    }\n  }\n  text-align: center;\n}\n\n","/* Reset default styles */\nhtml,\nbody,\ndiv,\nspan,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd {\n\tmargin: 0;\n\tpadding: 0;\n\tborder: 0;\n\toutline: 0;\n\t// font-size: 14px;font-sizefont-size\n\tvertical-align: baseline;vertical-align\n\tbackground: transparent;\n}\n\n/* HTML5 display-role reset for older browsers */\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmain,\nmenu,\nnav,\nsection {\n\tdisplay: block;\n}\n\nbody {\n\tline-height: 1;\n}\n\n.click {\n\tcursor: pointer;\n}\n\n// 一行缩略\n\n.txt-1-line {\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n}\n\n// 伪元素分割线\n\n.common-after-line::after {\n\tcontent: '';\n\tposition: absolute;\n\tleft: 0;\n\twidth: 100%;\n\theight: 1px;\n\tbackground-color: #f0f0f0;\n\ttransform: scaleY(0.5);\n\t-webkit-transform: scaleY(0.5);\n}\n\n.theme-dark .common-after-line::after {\n\t// background-color: @color-bg-root-dark;background-color\n}\n\n.after-icon::after {\n\tcontent: '';\n\tdisplay: inline-block;\n\tbackground-size: contain;\n\tbackground-position: center;\n\tbackground-repeat: no-repeat;\n\t// width: 24px;widthwidth\n\t// height: 24px;heightheight\n\t// background-image: url('~@/assets/images/rank/ic_topic.png');background-imagebackground-image\n}\n\n.before-icon::before {\n\tcontent: '';\n\tdisplay: inline-block;\n\tbackground-size: contain;\n\tbackground-position: center;\n\tbackground-repeat: no-repeat;\n}\n\n// 弹窗文案样式\n.dialog-msg {\n\t.van-dialog__message {\n\t\tfont-weight: 600;\n\t\tfont-size: 18px;\n\t\tline-height: 24px;\n\t\tcolor: rgba(0, 0, 0, 0.85);\n\t}\n}\n","@import './common.less';\n\nbody {\n\theight: 100%;\n\tmin-height: 100%;\n\tpadding: 0;\n\t-ms-text-size-adjust: 100%;\n\t-webkit-text-size-adjust: 100%;\n\t-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n\tfont-family:\n\t\t-apple-system,\n\t\tBlinkMacSystemFont,\n\t\tHelvetica Neue,\n\t\tPingFang SC,\n\t\tMicrosoft YaHei,\n\t\tSource Han Sans SC,\n\t\tNoto Sans CJK SC,\n\t\tWenQuanYi Micro Hei,\n\t\tsans-serif;\n\t-webkit-font-smoothing: antialiased;\n\t-moz-osx-font-smoothing: grayscale;\n\t-webkit-overflow-scrolling: touch;\n\tletter-spacing: 0.45px;\n\ttouch-action: manipulation;\n}\n\nh3,\np {\n\tmargin: 0;\n}\n\nol,\nul {\n\tmargin: 0;\n\tpadding: 0;\n\tlist-style: none;\n}\n\na {\n\ttext-decoration: none;\n}\n\n@media screen and (min-width: 540px) {\n\tbody {\n\t\tmax-width: 540px;\n\t\tmin-width: 320px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
